import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }
const _hoisted_2 = { class: "flex gap-2 border-b border-slate-200 bg-slate-50 px-5 py-3" }
const _hoisted_3 = { class: "space-y-4 px-5 py-5" }
const _hoisted_4 = { class: "flex items-center justify-end gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "space-y-4 px-5 py-5" }
const _hoisted_7 = { class: "flex items-center justify-end gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "fixed inset-0 z-[999] flex items-center justify-center p-4 backdrop-blur-sm bg-slate-900/50",
    onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", {
      class: "w-full max-w-[640px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl",
      onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[15] || (_cache[15] = _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-lg font-bold text-slate-900" }, "Tambah Penerima"),
          _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Tambahkan satu per satu atau impor dari CSV/XLS.")
        ], -1)),
        _createElementVNode("button", {
          type: "button",
          class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("svg", {
            class: "h-5 w-5",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["rounded-lg px-3 py-1.5 text-sm font-semibold transition-colors", _ctx.mode === 'manual' ? 'bg-[#003793] text-white' : 'text-slate-600 hover:bg-slate-200']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = 'manual'))
        }, " Manual ", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["rounded-lg px-3 py-1.5 text-sm font-semibold transition-colors", _ctx.mode === 'import' ? 'bg-[#003793] text-white' : 'text-slate-600 hover:bg-slate-200']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mode = 'import'))
        }, " Impor CSV / XLS ", 2)
      ]),
      (_ctx.mode === 'manual')
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitManual && _ctx.submitManual(...args)), ["prevent"])),
            novalidate: ""
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                  _createTextVNode("Nama "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name) = $event)),
                  type: "text",
                  class: "mt-1 block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. Budi Santoso"
                }, null, 512), [
                  [_vModelText, _ctx.form.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "NIM / Relasi", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.nim) = $event)),
                  type: "text",
                  class: "mt-1 block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. 13523062 atau Orang Tua Asuh"
                }, null, 512), [
                  [_vModelText, _ctx.form.nim]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "No. WhatsApp", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.noWhatsapp) = $event)),
                  type: "text",
                  class: "mt-1 block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. 6281234567890"
                }, null, 512), [
                  [_vModelText, _ctx.form.noWhatsapp]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.email) = $event)),
                  type: "email",
                  class: "mt-1 block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. nama@email.com"
                }, null, 512), [
                  [_vModelText, _ctx.form.email]
                ])
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-xs text-slate-400" }, "Minimal salah satu dari No. WhatsApp atau Email wajib diisi.", -1))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
              }, " Batal "),
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.isLoading,
                class: "rounded-lg bg-[#003793] px-6 py-2 text-sm font-bold text-white shadow-sm hover:bg-blue-800 transition-all disabled:cursor-not-allowed disabled:opacity-60"
              }, _toDisplayString(_ctx.isLoading ? 'Menyimpan...' : 'Simpan'), 9, _hoisted_5)
            ])
          ], 32))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitImport && _ctx.submitImport(...args)), ["prevent"])),
            novalidate: ""
          }, [
            _createElementVNode("div", _hoisted_6, [
              _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-xs text-slate-600\"><p class=\"font-semibold text-slate-700\">Format file:</p><p class=\"mt-1\">Header kolom: <span class=\"font-mono text-slate-900\">Nama</span>, <span class=\"font-mono text-slate-900\">NIM / Relasi</span>, <span class=\"font-mono text-slate-900\">No. WhatsApp</span>, <span class=\"font-mono text-slate-900\">Email</span></p><p class=\"mt-1\">Baris yang tidak memiliki Nama atau tidak memiliki WhatsApp &amp; Email akan dilewati.</p></div>", 1)),
              _createElementVNode("div", null, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                  _createTextVNode("File "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _createElementVNode("input", {
                  ref: "fileInput",
                  type: "file",
                  accept: ".csv,.xls,.xlsx",
                  class: "mt-1 block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 file:mr-3 file:rounded file:border-0 file:bg-[#003793] file:px-3 file:py-1.5 file:text-xs file:font-bold file:text-white",
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                }, null, 544),
                _cache[22] || (_cache[22] = _createElementVNode("p", { class: "mt-1 text-xs text-slate-400" }, "Maksimal 5MB. Format yang didukung: .csv, .xls, .xlsx", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
              }, " Batal "),
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.isLoading || !_ctx.selectedFile,
                class: "rounded-lg bg-[#003793] px-6 py-2 text-sm font-bold text-white shadow-sm hover:bg-blue-800 transition-all disabled:cursor-not-allowed disabled:opacity-60"
              }, _toDisplayString(_ctx.isLoading ? 'Mengimpor...' : 'Impor'), 9, _hoisted_8)
            ])
          ], 32))
    ])
  ]))
}